import { Typography } from '@mui/material';
import { CreatedFrom } from '../types';

type DisplayName =
    | 'AI Capture'
    | 'Capture'
    | 'CloudCapture'
    | 'IMA Upload'
    | 'WebEntry'
    | 'System'
    | 'PO Upload'
    | 'AI WebEntry';

const CreatedFromMapping: Record<CreatedFrom, { displayName: DisplayName } | undefined> = {
    [CreatedFrom.AIEngine]: {
        displayName: 'AI Capture',
    },
    [CreatedFrom.DeliveryWare]: {
        displayName: 'Capture',
    },
    [CreatedFrom.ExtractionProcessor]: {
        displayName: 'Capture',
    },
    [CreatedFrom.BatchUploadService]: {
        displayName: 'Capture',
    },
    [CreatedFrom.IDEEngine]: {
        displayName: 'Capture',
    },
    [CreatedFrom.IDEEngineParallel]: {
        displayName: 'Capture',
    },
    [CreatedFrom.DPSStructuredExtraction]: {
        displayName: 'Capture',
    },
    [CreatedFrom.AnyInvoice2IDE]: {
        displayName: 'CloudCapture',
    },
    [CreatedFrom.AnyInvoice2ScanKey]: {
        displayName: 'CloudCapture',
    },
    [CreatedFrom.AnyInvoice2AI]: {
        displayName: 'CloudCapture',
    },
    [CreatedFrom.CloudCaptureUnknownFile]: {
        displayName: 'CloudCapture',
    },
    [CreatedFrom.CloudCaptureUnsupportedType]: {
        displayName: 'CloudCapture',
    },
    [CreatedFrom.Workflow]: {
        displayName: 'IMA Upload',
    },
    [CreatedFrom.WebEntry]: {
        displayName: 'WebEntry',
    },
    [CreatedFrom.AutoResponse]: {
        displayName: 'System',
    },
    [CreatedFrom.WebUpload]: {
        displayName: 'PO Upload',
    },
    [CreatedFrom.AIWebEntry]: {
        displayName: 'AI WebEntry',
    },
    [CreatedFrom.Undefined]: undefined,
};

export function CreatedFromLabel({ createdFrom }: { createdFrom: CreatedFrom | null }) {
    if (!createdFrom) {
        return null;
    }

    const displayInfo = CreatedFromMapping[createdFrom];

    if (!displayInfo) {
        return null;
    }

    return (
        <Typography>
            <Typography component="span" fontWeight="bold">
                Created from:{' '}
            </Typography>
            {displayInfo.displayName}
        </Typography>
    );
}
